import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function usePage(): string {
  try {
    const location = useLocation();
    return location.pathname.split('/')[1] || '';
  } catch {
    return 'unknown';  // Возвращаем безопасное значение
  }
}
